import { Box } from '@mui/material';
import { styled } from '@mui/material/styles';

export const CalendarWithPanelLayout = styled(Box)({
  gap: '0.5rem',
  height: '100%',
  display: 'grid',
  overflow: 'hidden',
  gridTemplateColumns: 'minmax(0, 1fr) 20rem',
});
